import React, { useState } from "react";
import { FilterDropdown } from "./FilterDropdown";

interface Option {
  label: string;
  value: string;
}

interface Props {
  title: string;
  value: string;
  setValue: (v: string) => void;
  options: Option[];
  width?: string;
}

export function SingleSelectFilter({
  title,
  value,
  setValue,
  options,
  width,
}: Props) {
  const [open, setOpen] = useState(false);

  const toggle = (v: string) => {
    setValue(value === v ? "" : v);
  };

  return (
    <FilterDropdown
      label={title}
      count={value ? 1 : 0}
      open={open}
      setOpen={setOpen}
      width={width}
      scrollable
    >
      {options.map((opt) => {
        const selected = value === opt.value;

        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            className="w-full text-left px-4 py-3 rounded-[14px] hover:bg-[#F3F4F6]"
          >
            <div className="flex items-start gap-3">
              <div className="mt-1 w-4 h-4 rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
                {selected && (
                  <div className="w-2 h-2 rounded-full bg-[#9333EA]" />
                )}
              </div>

              <span className="text-[16px]">
                {opt.label}
              </span>
            </div>
          </button>
        );
      })}

      {/* All */}
      <button
        type="button"
        onClick={() => setValue("")}
        className="w-full text-left px-4 py-3 rounded-[14px] hover:bg-[#F3F4F6]"
      >
        All
      </button>
    </FilterDropdown>
  );
}
